import React, {useEffect } from 'react';
import {connect} from 'react-redux'
import {addBreadcrumb, setPrefernceItem} from '../redux/actions'
import {
  Switch,
  Redirect,
  Route,
  Link,
  useLocation
} from "react-router-dom";

const BASE_PATH = "http://localhost:3000/#/";

const routs = [
  { path: "/login", name: "",},
  { path: "/register", name: ""},
  { path: "/about", name: "",},

  { path: "/choose", name: "",},
  { path: "/choose/optionItem", name: "",},
  { path: "/choose/preferenceItem", name: "",},

];

const linkToBase = "";

const LinkManager = (props) => {


}

function useQuery(){
  return new URLSearchParams(useLocation().search);
}

export function useListeanUrl(){
  const query = URLSearchParams(useLocation().search);
}

const mapStateToProps = (state) => ({
  queryParams: state.optionQueryParams,
})

const actionsCreators = {
  addBreadcrumb: addBreadcrumb,
  setPrefernceItem: setPrefernceItem
}

export const OptionLink = connect(mapStateToProps, actionsCreators)(
  props =>
    <Link to={`/choose/optionItem?category=${props.queryParams.category}&treeId=${props.queryParams.treeId}&ordering=-score&itemId=${props.optionId}`}
      onClick={()=>{window.scrollTo(0, 0)}}>
      {props.children}
    </Link>
)

export const OptionRedirect = connect(mapStateToProps, null)(
  props =>
  <Redirect to={`/choose/optionItem?category=${props.queryParams.category}&treeId=${props.queryParams.treeId}&ordering=-score&itemId=${props.optionId}`}/>
)

export const PrefernceLink = connect(mapStateToProps, actionsCreators)(
  props =>{
    if(props.prefData){
      return(
        <Link onClick={()=> props.setPrefernceItem(props.prefData)} to={`/choose/preferenceItem?category=${props.queryParams.category}&treeId=${props.queryParams.treeId}&ordering=-score&node_id=${props.prefData.id}`}>
          {props.children}
        </Link>)
    }
    else return <div></div>
}
)
